import { useFocusedWorkspaceItemContext } from '../../app/contexts/workspace/workspace-item-context';

export default function useRouteAnalyzerLayer() {
    return useFocusedWorkspaceItemContext().routeAnalyzerLayer;
}
